module.exports = __webpack_public_path__ + "static/Kotlin-4356ac78223a60a63c6e05d93c13a6e2.png";